// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3Xeb-","left":"InfoRow_left__1DExR"};